/* eslint-disable jira/filename-case */
// EVENT TYPES
export const UI_EVENT_TYPE = 'UI' as const;
export const TRACK_EVENT_TYPE = 'TRACK' as const;
export const SCREEN_EVENT_TYPE = 'SCREEN' as const;
export const OPERATIONAL_EVENT_TYPE = 'OPERATIONAL' as const;

// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
export enum SHORTCUT_ELEMENT_TYPES {
	THEN = 'then',
	OR = 'or',
	PLUS = 'plus',
	KEY = 'key',
}

export const COMMAND_PALETTE_DEBOUNCE_DEFAULT = 250;
